import { App } from "vue";
import { toastService } from "@/utils/toast-service";

export default {
  install(app: App) {
    // Provide $toast for Options API components
    app.config.globalProperties.$toast = toastService;

    // Provide via inject for Composition API
    app.provide("toast", toastService);
  },
};
